import styled from 'styled-components';

export const Wrapper = styled.div`
    display: block;
`;

export const Options = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 36px;
    @media (max-width: 1279px) {
        margin-right: 16px;
    }
    @media (max-width: 360px) {
        margin-right: 6px;
    }
`;
